import { gql, useMutation } from 'urql';

export const CREATE_FORM = gql`
  mutation CreateForm($name: String!, $maxExtraChildren: Int!, $maxExtraAdults: Int!) {
    createForm(createFormData: { name: $name, maxExtraChildren: $maxExtraChildren, maxExtraAdults: $maxExtraAdults }) {
      id
      name
      maxExtraChildren
      maxExtraAdults
    }
  }
`;

export interface CreateFormData {
  name: string;
  maxExtraChildren: number;
  maxExtraAdults: number;
}

export const useCreateForm = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation(CREATE_FORM);

  const createForm = (variables: CreateFormData) => {
    return executeMutation(variables);
  };

  return { data, error, fetching, createForm };
};
